/* Small presentation enhancements; native Shopify commerce stays in control. */
(() => {
  function updateSupportAddress(root = document) {
    const oldAddresses = ["varun@cloudcomfort.in", "varun@livingcentury.co.in"];
    const newAddress = "contact@cloudcomfort.in";
    const content = root === document ? document.getElementById("MainContent") : root;
    if (!content) return;
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.parentElement?.closest("script, style, textarea, input, [contenteditable]"))
          return NodeFilter.FILTER_REJECT;
        return oldAddresses.some(address => node.nodeValue.includes(address))
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      oldAddresses.forEach(address => { node.nodeValue = node.nodeValue.replaceAll(address, newAddress); });
    });
    content.querySelectorAll('a[href^="mailto:"]').forEach(link => {
      const address = link.getAttribute("href");
      let updated = address;
      oldAddresses.forEach(oldAddress => { updated = updated.replaceAll(oldAddress, newAddress); });
      if (updated !== address) link.setAttribute("href", updated);
    });
  }

  function updatePolicyLinks(root = document) {
    // Temporary display correction until the stored Shopify policies are updated.
    // Only known policy placeholders are linked; customer input and app content are excluded.
    root.querySelectorAll(".shopify-policy__body").forEach(body => {
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (node.parentElement?.closest("a, script, style, textarea, input, [contenteditable]"))
            return NodeFilter.FILTER_REJECT;
          return node.nodeValue.includes("[LINK]") ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        },
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const pattern = /(privacy policy|refund policy)(, which can be viewed here)?\s*\[LINK\]/gi;
        const fragment = document.createDocumentFragment();
        let previous = 0;
        let matched = false;
        for (const match of node.nodeValue.matchAll(pattern)) {
          matched = true;
          fragment.append(document.createTextNode(node.nodeValue.slice(previous, match.index)));
          const link = document.createElement("a");
          link.href = match[1].toLowerCase() === "refund policy"
            ? "/policies/refund-policy" : "/policies/privacy-policy";
          link.textContent = match[1];
          fragment.append(link);
          if (match[2]) fragment.append(document.createTextNode(match[2]));
          previous = match.index + match[0].length;
        }
        if (!matched) return;
        fragment.append(document.createTextNode(node.nodeValue.slice(previous)));
        node.replaceWith(fragment);
      });
    });
  }

  function initProductDetailsLinks(root = document) {
    root.querySelectorAll("a[data-cc-product-details-id]").forEach(link => {
      // The initial full URL works in native quick-view, whose HTML excludes the details section.
      // On the full product page use its existing anchor, preserving the selected variant URL.
      if (!link.closest("quick-add-modal") && document.getElementById(link.dataset.ccProductDetailsId))
        link.setAttribute("href", `#${link.dataset.ccProductDetailsId}`);
    });
  }

  document.addEventListener("click", event => {
    const link = event.target.closest?.("a[data-cc-product-details-id]");
    if (!link?.closest("quick-add-modal")) return;
    const variantId = link.closest("product-info")?.querySelector('product-form input[name="id"]')?.value;
    if (!variantId) return;
    const destination = new URL(link.href);
    destination.searchParams.set("variant", variantId);
    link.setAttribute("href", `${destination.pathname}${destination.search}${destination.hash}`);
  });

  function initArticle(root = document) {
    const article = root.querySelector(".article-template");
    if (!article || article.querySelector(".cc-article-toc")) return;
    const content = article.querySelector(".article-template__content");
    if (!content) return;
    const headings = [...content.querySelectorAll("h2")].filter((heading) =>
      heading.textContent.trim(),
    );
    if (headings.length < 4) return;
    const details = document.createElement("details");
    details.className = "cc-article-toc";
    const summary = document.createElement("summary");
    summary.textContent = "In this article";
    const list = document.createElement("ol");
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `cc-article-section-${index + 1}`;
        while (document.getElementById(id)) id += "-section";
        heading.id = id;
      }
      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    details.append(summary, list);
    content.before(details);
  }
  function init(root = document) {
    initArticle(root);
    updateSupportAddress(root);
    updatePolicyLinks(root);
    initProductDetailsLinks(root);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => init());
  else init();
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
})();
